/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * OrderTagDtoBase
 * auto generated base class for the model OrderTagDtoModel.
 */
export const OrderTagDtoModelBase = ModelBase
  .named('OrderTagDto')
  .props({
    __typename: types.optional(types.literal("OrderTagDto"), "OrderTagDto"),
    uuid: types.union(types.undefined, types.string),
    name: types.union(types.undefined, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class OrderTagDtoModelSelector extends QueryBuilder {
  get uuid() { return this.__attr(`uuid`) }
  get name() { return this.__attr(`name`) }
}
export function selectFromOrderTagDto() {
  return new OrderTagDtoModelSelector()
}

export const orderTagDtoModelPrimitives = selectFromOrderTagDto().uuid.name
